import type { CaRowConfig } from "./types";

/**
 * Mirrors the caRows array from template.html exactly.
 * 52 rows + section headers.
 */
export const CAPITAL_ACCOUNT_ROWS: CaRowConfig[] = [
  { type: "section", label: "General Information" },
  { label: "Fund Name", keyF: "general_information_fund_name", isSingle: true },
  {
    label: "Share (%)",
    keyF: "general_information_share_pct",
    isSingle: true,
    isPct: true,
  },
  {
    label: "Reporting Date",
    keyF: "general_information_reporting_date",
    isSingle: true,
  },
  {
    label: "Reporting Currency",
    keyF: "general_information_reporting_currency",
    isSingle: true,
  },
  { label: "Tax ID", keyF: "general_information_tax_id", isSingle: true },
  {
    label: "Transparency Register",
    keyF: "general_information_transparency_register",
    isSingle: true,
  },
  {
    label: "Fund Status",
    keyF: "general_information_fund_status",
    isSingle: true,
  },

  { type: "section", label: "Capital Account since Inception" },
  {
    label: "Total commitment",
    keyF: "since_inception_total_commitment_fund",
    keyS: "since_inception_total_commitment_share",
    isNum: true,
  },
  {
    label: "Unfunded commitment",
    keyF: "since_inception_unfunded_commitment_fund",
    keyS: "since_inception_unfunded_commitment_share",
    isNum: true,
  },
  {
    label: "Paid in capital (Total)",
    keyF: "since_inception_paid_in_capital_fund",
    keyS: "since_inception_paid_in_capital_share",
    isNum: true,
  },
  {
    label: "Distributions (Total)",
    keyF: "since_inception_distributions_total_fund",
    keyS: "since_inception_distributions_total_share",
    isNum: true,
  },
  {
    label: "thereof return of Capital",
    keyF: "since_inception_distributions_thereof_return_of_capital_fund",
    keyS: "since_inception_distributions_thereof_return_of_capital_share",
    isNum: true,
  },
  {
    label: "thereof gain/loss",
    keyF: "since_inception_distributions_thereof_gain_loss_fund",
    keyS: "since_inception_distributions_thereof_gain_loss_share",
    isNum: true,
  },
  {
    label: "Recallable distributions (Total)",
    keyF: "since_inception_recallable_distributions_total_fund",
    keyS: "since_inception_recallable_distributions_total_share",
    isNum: true,
  },
  {
    label: "thereof already recalled",
    keyF: "since_inception_recallable_distributions_thereof_already_recalled_fund",
    keyS: "since_inception_recallable_distributions_thereof_already_recalled_share",
    isNum: true,
  },
  {
    label: "thereof current recallable",
    keyF: "since_inception_recallable_distributions_thereof_current_recallable_fund",
    keyS: "since_inception_recallable_distributions_thereof_current_recallable_share",
    isNum: true,
  },
  {
    label: "Realized gain/losses",
    keyF: "since_inception_realized_gains_fund",
    keyS: "since_inception_realized_gains_share",
    isNum: true,
  },
  {
    label: "Unrealized gain/losses",
    keyF: "since_inception_unrealized_gains_fund",
    keyS: "since_inception_unrealized_gains_share",
    isNum: true,
  },
  {
    label: "Operating Income and expenses",
    keyF: "since_inception_op_income_other_fund",
    keyS: "since_inception_op_income_other_share",
    isNum: true,
  },
  {
    label: "Equalisation paid by LP",
    keyF: "since_inception_equalisation_paid_by_lp_fund",
    keyS: "since_inception_equalisation_paid_by_lp_share",
    isNum: true,
  },
  {
    label: "Equalisation paid to LP",
    keyF: "since_inception_equalisation_paid_to_lp_fund",
    keyS: "since_inception_equalisation_paid_to_lp_share",
    isNum: true,
  },
  {
    label: "Management fees paid",
    keyF: "since_inception_management_fees_paid_fund",
    keyS: "since_inception_management_fees_paid_share",
    isNum: true,
  },
  {
    label: "Net Asset Value before Carry",
    keyF: "since_inception_nav_before_carry_fund",
    keyS: "since_inception_nav_before_carry_share",
    isNum: true,
  },
  {
    label: "Total carried interest - accrued",
    keyF: "since_inception_carry_accrued_fund",
    keyS: "since_inception_carry_accrued_share",
    isNum: true,
  },
  {
    label: "Total carried interest - paid",
    keyF: "since_inception_carry_paid_fund",
    keyS: "since_inception_carry_paid_share",
    isNum: true,
  },
  {
    label: "Net Asset Value after Carry",
    keyF: "since_inception_nav_after_carry_fund",
    keyS: "since_inception_nav_after_carry_share",
    isNum: true,
  },
  {
    label: "TVPI (after carry)",
    keyF: "since_inception_tvpi_fund",
    keyS: "since_inception_tvpi_share",
    isNum: true,
    suffix: "x",
  },
  {
    label: "DPI (after carry)",
    keyF: "since_inception_dpi_fund",
    keyS: "since_inception_dpi_share",
    isNum: true,
    suffix: "x",
  },
  {
    label: "RVPI (after carry)",
    keyF: "since_inception_rvpi_fund",
    keyS: "since_inception_rvpi_share",
    isNum: true,
    suffix: "x",
  },
  {
    label: "Gross IRR after carry (%)",
    keyF: "since_inception_gross_irr_pct_fund",
    keyS: "since_inception_gross_irr_pct_share",
    isPct: true,
  },
  {
    label: "Net IRR after carry (%)",
    keyF: "since_inception_net_irr_pct_fund",
    keyS: "since_inception_net_irr_pct_share",
    isPct: true,
  },

  { type: "section", label: "Capital Account for current Quarter" },
  {
    label: "Paid in capital",
    keyF: "current_quarter_paid_in_capital_fund",
    keyS: "current_quarter_paid_in_capital_share",
    isNum: true,
  },
  {
    label: "Distributions (Total)",
    keyF: "current_quarter_distributions_total_fund",
    keyS: "current_quarter_distributions_total_share",
    isNum: true,
  },
  {
    label: "thereof return of Capital",
    keyF: "current_quarter_distributions_thereof_return_of_capital_fund",
    keyS: "current_quarter_distributions_thereof_return_of_capital_share",
    isNum: true,
  },
  {
    label: "thereof gain/loss",
    keyF: "current_quarter_distributions_thereof_gain_loss_fund",
    keyS: "current_quarter_distributions_thereof_gain_loss_share",
    isNum: true,
  },
  {
    label: "Recallable distributions",
    keyF: "current_quarter_recallable_distributions_total_fund",
    keyS: "current_quarter_recallable_distributions_total_share",
    isNum: true,
  },
  {
    label: "Realized portfolio gain/losses",
    keyF: "current_quarter_realized_gains_fund",
    keyS: "current_quarter_realized_gains_share",
    isNum: true,
  },
  {
    label: "Operating Income and expenses",
    keyF: "current_quarter_op_income_other_fund",
    keyS: "current_quarter_op_income_other_share",
    isNum: true,
  },
  {
    label: "Equalisation paid by Investor",
    keyF: "current_quarter_equalisation_paid_by_fund",
    keyS: "current_quarter_equalisation_paid_by_share",
    isNum: true,
  },
  {
    label: "Equalisation paid to Investor",
    keyF: "current_quarter_equalisation_paid_to_fund",
    keyS: "current_quarter_equalisation_paid_to_share",
    isNum: true,
  },
  {
    label: "Management fees paid",
    keyF: "current_quarter_management_fees_paid_fund",
    keyS: "current_quarter_management_fees_paid_share",
    isNum: true,
  },
  {
    label: "Net Asset Value before Carry",
    keyF: "current_quarter_nav_before_carry_fund",
    keyS: "current_quarter_nav_before_carry_share",
    isNum: true,
  },
  {
    label: "Total carried interest - accrued",
    keyF: "current_quarter_carry_accrued_fund",
    keyS: "current_quarter_carry_accrued_share",
    isNum: true,
  },
  {
    label: "Total carried interest - paid",
    keyF: "current_quarter_carry_paid_fund",
    keyS: "current_quarter_carry_paid_share",
    isNum: true,
  },
  {
    label: "Net Asset Value after Carry",
    keyF: "current_quarter_nav_after_carry_fund",
    keyS: "current_quarter_nav_after_carry_share",
    isNum: true,
  },
];

// Backward-compatible alias (can be removed after import cleanup).
export const CA_ROWS = CAPITAL_ACCOUNT_ROWS;
